import {Button, notification} from "antd";
import React from "react";

export const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};


export function convertRialToToman(x) {
    if(x){
        return x/10
    }else {
        return "0"
    }
}

export function convertTomanToRial(x) {
    if(x){
        return x*10
    }else {
        return "0"
    }
}


export function numberWithCommas(x) {
    // convert To toman
    // x= (x/10).toFixed(0)
    //add commas
    if(x){
        return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
    }else {
        return "0"
    }
}

export const isInStandaloneMode = () =>
    window.matchMedia('(display-mode: standalone)').matches;

// 'standalone' in window.navigator && window.navigator.standalone;

// isInWebAppiOS = (window.navigator.standalone == true);

export const isInWebAppChrome = () =>
    window.matchMedia('(display-mode: standalone)').matches;

export const ConvertTMonthName = (month) =>{
    let name= "";
    switch (month) {
        case '01':
            name =  "فروردین";
            break;
        case '02':
            name =  "اردیبهشت";
            break;
        case '03':
            name =  "خرداد";
            break;
        case '04':
            name =  "تیر";
            break;
        case '05':
            name =  "مرداد";
            break;
        case '06':
            name =  "شهریور";
            break;
        case '07':
            name =  "مهر";
            break;
        case '08':
            name =  "آبان";
            break;
        case '09':
            name =  "آذر";
            break;
        case '10':
            name =  "دی";
            break;
        case '11':
            name =  "بهمن";
            break;
        case '12':
            name =  "اسفند";
            break;
        default:
            name =  "---";
    }

    return name;
}


export const
    fixNumbers = function (str)
    {
        str = str.replace(/\s+/g, '');
        let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
        let arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if(typeof str === 'string')
        {
            for(let i=0; i<10; i++)
            {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

export const  detectEnglishLang = (text)=>{
    return (/^[a-zA-Z]+$/.test(text)) //if the English language
}



export const openNotificationWithIcon = (type,product,history,merchantId) => {
    const key = `open${Date.now()}`;
    const btn = (
        <Button type="primary" size="small" onClick={() => {
            notification.close(key)
            history.push(`/dr-shop/basket/${merchantId}`)
        }}>
            رفتن به سبد
        </Button>
    );

    notification.config({
        duration: 3,
    });

    notification[type]({
        message: ` ${ product.name } به سبد شما اضافه شد`,
        btn,
        key,
        style: {
            zIndex:2003
        },
    });
}

export const  getMallColor = ()=>{

    let theme = localStorage.getItem("theme")
    if(theme){
        let t = JSON.parse(theme)
        if(t.primary)
        return {primary:t.primary,secondary:t.secondary}
        else
        return {primary:"#31ccef",secondary:"#31ccef"}
    }
    else{
        return {primary:"#31ccef",secondary:"#31ccef"}
    }

}
